import { createStore } from "vuex";

export default createStore({
  state: {
    logged: false,
    validated: false,
    clickedEdit: null,
    banks: {},
    modules: {},
    sched: {},
    forgot_password_payload:{
      uuid:null,
      hash:null,
      pin:null,
    },
    recovery:{
      hash:null,
      pin:null,
      otp_token:null,
      otp_pin:null,
      uuid:null,
    },
    election_config:{
      code:'GA00000002',
      server_time:null,
      date_start : null,
      date_end: null,
      can_vote:null,
      started:false,
      voted:null,
      registration_start:null,
      registration_end:null,
      registration_ended:null,
      registration_started:null,
      election_registered:null,
      voting_ended:null,
      finished:false,
      ballot_no:null,
      total_votes:null,
      voter_key:null,
    },
    sga_config: {
      code: null,
      date: null,
      title: null,
      uuid: null,
      eligible: null,
      has_voted: null,
      has_registered: null,
      schedules: {
        has_started: null,
        has_ended: null,
        start_date: null,
        end_date: null,
      }
    },
    credentials: {
      noContact: null,
      enrolled_pin: null,
      edit_temporary: null,
      express:null,
      first_name:null,
      last_name:null,
      middle_name:null,
      suffix: null,
      birthdate: null,
      skipped_info: null,
      age: null,
      gender:null,
      regular:null,
      account_no : null,
      serial_no : null,
      email : null,
      mobile : null,
      pso_enroll: null,
      pin_update: null,
      tin:null,
      has_pin:null,
      name : null,
      otp:null,
      username : null,
      password : null,
      membership_type:null,
      membership_date:null,
      status:null,
      registered_date:null,
      qr : null,
      uuid : null,
      hash : null,
      key : null,
      deactivated:null,
      config: {
        type: null,
        status: null,
      }
    },
    membership_details: {
      ref_account:null,
      ref_name:null,
      confirmed:null,
      interview_date: null,
      pso:null,
      citizenship:null,
      sss_number:null,
      gsis_number:null,
      first_name: null,
      last_name: null,
      middle_name: null,
      rank: null,
      birth_date: null,
      place_of_birth: null,
      gender: null,
      suffix:null,
      civil_status: null,
      snap:null,
      afp_serial_number: null,
      branch_of_service: null,
      employee_status: null,
      gender_text:null,
      employee_status_text:null,
      civil_status_text:null,
      branch_of_service_text:null,
      rank_text:null,
      schedule_key:null,
      pso_text:null,
      tin: null,
      mobile: null,
      email: null,
      re_email:null,
      mofirst_name: null,
      molast_name: null,
      momiddle_name: null,  
      fafirst_name: null,
      falast_name: null,
      famiddle_name: null, 
      spfirst_name: null,
      splast_name: null,
      spmiddle_name: null,
      spfirst_name2: null,
      splast_name2: null,
      spmiddle_name2: null,
      spfirst_name3: null,
      splast_name3: null,
      spmiddle_name3: null,
      spfirst_name4: null,
      splast_name4: null,
      spmiddle_name4: null,
      beneficiaries:[],  
      spouse:[],
      resstreet_address: null,
      reszip_code: null,
      resprovince: null,
      rescity: null,
      resbrngy: null,
      altstreet_address: null,
      altzip_code: null,
      altprovince: null,
      altcity: null,
      altbrngy:null,
      signature:null,
      front:null,
      back:null,
      sc:null,
      sc_agree:null,
      wcp_agree:null,
      cisa_agree:null,
      pmes_dt:null,
      email_pin:null,
      phone_pin:null,
    },
    user:{
      selected_candidatesBodOf:null,
      selected_candidatesBodEp:null,
      selected_candidatesBodCv:null,
      selected_candidatesElecomOf:null,
      selected_candidatesElecomEp:null,
      selected_candidatesElecomCv:null,
      selected_candidatesAudit:null,
      date_started:null,
      date_submitted:null,
      skip:true,
    },
    references:{
      branch_of_service:[],
      employment_status_options:[],
      branches:[],
      civil_status:[],
      gender:[],
      ranks:[],
    }
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
